import React from 'react';
import './index.scss';
const ShareBtn = props => {
	function handleClick() {
		props.onClick();
	}

	return (
		<i className="iconfont share-btn" onClick={handleClick}>
			&#xe657;
		</i>
	);
};
export { ShareBtn };
